import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

const ArtistItem = styled.div`
  position: relative;
  cursor: pointer;
  width: 125px;
  &:before{
    content: '';
    background: url(/images/homeNew/avatarCheck.png);
    z-index: 1;
    left: 100px;
    top: 100px;
    z-index: 1;
    width: 30px;
    height: 30px;
    position: absolute;
    background-repeat: no-repeat;
  }
`

const Avatar = styled.img`
  width: 125px;
  height: 125px;
  border-radius: 100%;
  position: relative;
  margin-top: 1px;
  margin-left: 1px;
`

const Nick = styled.div`
  margin-top: 16px;
  word-break: break-all;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    transform: scale(1.3);
  `}
`

export default function ArtistCard({artist}: {artist: any}) {
  const history = useHistory();
  const goUser = () => {
    console.log("artist.address",artist.address)
    history.push(`/usercenter/${artist.address}?type=CREATED`)
  }

  return(
    <ArtistItem onClick={() => goUser()}>
      <Avatar src={artist.avatar ? artist.avatar : '/images/icon/default.png'}></Avatar>
      <Nick>{artist.nick ? artist.nick : 'Unnamed'}</Nick>
    </ArtistItem>
  )
}